/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import { Modal, useTheme } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

const CustomModal = ({
  children,
  ...otherProps
}: {
  children: React.ReactNode;
  open: boolean;
  disableBackdropClick?: boolean;
}): JSX.Element => {
  const theme: ICustomTheme = useTheme();
  const cssModalContent = css({
    alignItems: 'center',
    backgroundColor: theme.colors.white,
    border: 'none',
    boxShadow: theme.shadows[5],
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    height: 353,
    justifyContent: 'center',
    padding: theme.spacing(0, 21),
    textAlign: 'center',
    width: 800,
    ':focus': {
      outline: 'none',
    },
  });

  return (
    <Modal
      css={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      {...otherProps}
    >
      <div css={cssModalContent}>{children}</div>
    </Modal>
  );
};

export default CustomModal;
